module.exports = __webpack_public_path__ + "img/lisa.d93651f8.jpg";